import axiosClient from "./axiosClient.js";

const quickMessageApi = {
  getByShopId: (shopId) => {
    const url = `/quickMessages/getByShopId/${shopId}`;
    return axiosClient.post(url);
  },
  create: (data) => {
    const url = `/quickMessages/create`;
    return axiosClient.post(url, data);
  },
  updateById: (data) => {
    const url = `/quickMessages/updateById`;
    return axiosClient.put(url, data);
  },
};

export default quickMessageApi;
